export type LegendHexColorMap = { label: string; color: string }[]
export type LegendHexColorMaps = Record<string, LegendHexColorMap>

/**
 * Per-visual channel settings for layer legent entry.
 */
export interface LayerLegendEntrySettings {
  visualChannel: string
  customFieldLabel?: string
  customColorLabels?: string[]
  hash?: string
}

export interface LayerLegendSettings {
  /**
   * If active, a layer is shown in the layer list panel (optionally with legends),
   * and enabled for exports. If inactive, the layer and all legend entries are
   * hidden and the layer is excluded from exports.
   *
   * Prior to March 2025, this property was used only to show/hide legend
   * entries, but not to remove the layer from the layer list and exports. Map
   * configs have since been migrated, and the old behavior is now described by
   * the `shouldDisplayEntries` property below.
   */
  active: boolean
  /**
   * Whether or not a layer's legend entries are shown.
   *
   * Prior to March 2025, this behavior was described by the `active` property above.
   */
  shouldDisplayEntries: boolean
  entries?: LayerLegendEntrySettings[]
}

export const DEFAULT_MAP_INDEX = 0
export const SPLIT_MAP_INDEX = 1
export type MapIndex = typeof DEFAULT_MAP_INDEX | typeof SPLIT_MAP_INDEX

export enum LegendSettingsVersion {
  // v0, active means "legend is not visible for this layer", but _layer_ is on list
  V0 = 'v0',

  // v1, active means hide/show legend for this layer and if false, it's completly unavailable also for export
  // v1, shouldDisplayEntries means what "active" means in v0
  V1 = 'v1'
}

export interface LegendSettings {
  initialExpanded?: boolean // Some Maps published without the `expanded` property might have this, so we need to keep it for backwards compatibility
  expanded: { [DEFAULT_MAP_INDEX]: boolean; [SPLIT_MAP_INDEX]?: boolean }
  baseMapSelector?: boolean
  layers: Record<string, LayerLegendSettings>
  version?: LegendSettingsVersion
}
